export default function () {
  const widgetName = 'cardWidgetFourthFeature';
  const widgetOpts = cardWidgetFourthFeatureOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function () {
      function removeAtt() {
        $(".moreButton").attr("target", "");
        $(".moreButton").attr("class", "button");
      }
      removeAtt()
    },

    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [''], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false
  });

}